<template>
    <SOSlotModal :modal-title="getModalTitle" :modal-id="modalId" @close="back">
        <template v-slot:modal-body>
            <div class="">
                <div class="m-d-20">
                    <label class="m-d-0 f-regular f-c-midgrey f-14">Cari {{ getModalTitle }}</label>
                    <SOInputSearch
                        id="search-item"
                        :value="searchKey"
                        :do-searching="searchItem"
                        @input="setSearchKey"
                    />
                </div>
                <!-- <div class="check-list">
                    <div class="d-flex check-all" @click="onSelectItem('all')">
                        <SOCheckBox :is-checked="isCheckAll" />
                        <label class="m-l-8 m-d-0">Pilih Semua</label>
                    </div>
                    <div class="list-item-container">
                        <div
                            class="d-flex list-item"
                            v-for="(opt, idx) in options"
                            :key="`opt-item${idx}`"
                            @click="onSelectItem('item_id')"
                        >
                            <SOCheckBox :is-checked="isCheckedItem(opt) || isCheckAll" />
                            <label class="m-l-8 m-d-0">{{ opt.nama }}</label>
                        </div>
                    </div>
                </div> -->
                <SODeepChecklist
                    :group-by="optGroupBy"
                    :is-check-all="isCheckAll"
                    :use-check-all-option="true"
                    :selected-options="selectedOption"
                    :options="options"
                    :label-key="getLabelDisplay"
                    :label-val="getLabelVal"
                    @onSelect="onSelectItem"
                />
            </div>
        </template>
        <template v-slot:modal-footer>
            <div class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white">
                <div class="btn_actions col-md-6 col-sm-6 col-6 p-0 pr-1 pl-1">
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Batal'"
                        :id="'batal-save-options'"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="back"
                    />
                </div>
                <div class="btn_actions col-md-6 col-sm-6 col-6 p-0 pr-1 pl-1">
                    <SOButton
                        :primary="true"
                        :full="true"
                        :text="'Simpan'"
                        :id="`save-options`"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="doSave"
                    />
                </div>
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../../store/state";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox.vue";
import SODeepChecklist from "@/so-components/global/ui/SODeepChecklist.vue";

export default {
    name: "PilihSumberBiaya",
    components: {
        SOSlotModal,
        SOButton,
        SOInputSearch,
        SOCheckBox,
        SODeepChecklist,
    },
    data() {
        return {
            modalTitle: "Sumber Dana",
            modalId: "pilih-sumber-dana",
            searchKey: "",
            isCheckAll: false,
            isFetching: false,
            optGroupBy: "nama_kategori",
            options: [],
            selectedOption: [],
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $("#" + this.modalId).modal("show");
        this.init();
    },
    computed: {
        ...mapGetters(moduleName, {
            pengaturanLaporan: "pengaturanLaporan",
        }),
        isSumberDana() {
            return this.$route.params.pengaturan === "sumber-dana";
        },
        isBiayaItem() {
            return this.$route.params.pengaturan === "item-biaya";
        },
        getModalTitle() {
            return this.modalTitle;
        },
        isCheckedItem() {
            return (item) => {
                let existing = this.selectedOption.find((opt) => opt.id === item.id);

                return existing !== undefined ? true : false;
            };
        },
        getLabelDisplay() {
            return this.isSumberDana ? "nama_akun" : "nama";
        },
        getLabelVal() {
            return this.isSumberDana ? "idakun" : "id";
        },
        getItemBiaya() {
            return this.pengaturanLaporan.itemBiaya;
        },
        selectedItemBiaya() {
            let selectedItem = this.getItemBiaya.filter((item) => item.hide === 1);
            return selectedItem ? selectedItem : 0;
        },
        getSumberDana() {
            return this.pengaturanLaporan.sumberDana;
        },
        selectedSumberDana() {
            let selectedDana = this.getSumberDana.filter((item) => item.hide === 1);
            return selectedDana ? selectedDana : 0;
        },
    },
    methods: {
        ...mapActions(moduleName, {
            savePengaturanSumberDana: "savePengaturanSumberDana",
            savePengaturanItemBiaya: "savePengaturanItemBiaya",
            getPengaturanLaporan: "getPengaturanLaporan",
            setSumberDana: "setSumberDana",
            setItemBiaya: "setItemBiaya",
        }),
        async init() {
            await this.setModalTitle();
            if (this.isBiayaItem) {
                this.options = this.getItemBiaya;
            }

            if (this.isSumberDana) {
                this.options = this.getSumberDana;
            }

            await this.selectedItem();
        },
        selectedItem() {
            if (this.isBiayaItem) {
                this.selectedOption = this.getItemBiaya.filter((item) => item.hide === 1);
            }

            if (this.isSumberDana) {
                this.selectedOption = this.getSumberDana.filter((item) => item.hide === 1);
            }
        },
        setModalTitle() {
            this.modalTitle = this.isBiayaItem ? "Item Biaya" : "Sumber Dana";
        },
        setSearchKey(val) {
            this.searchKey = val;
        },
        async onSelectItem(val) {
            if (val === "all") {
                this.isCheckAll = !this.isCheckAll;
            } else {
                if (val[this.getLabelVal]) {
                    let exist = this.selectedOption.find((opt) => opt[this.getLabelVal] === val[this.getLabelVal]);
                    if (!exist) {
                        this.selectedOption.push(val);
                    } else {
                        let newGroup = this.selectedOption.filter(
                            (opt) => opt[this.getLabelVal] !== val[this.getLabelVal]
                        );
                        this.selectedOption = newGroup;
                    }
                } else {
                    await this.clearOptionByGroup(val);
                    this.options
                        .filter((opt) => opt[this.optGroupBy] === val)
                        .forEach((opt) => {
                            this.selectedOption.push(opt);
                        });
                }
            }
        },
        clearOptionByGroup(group) {
            let newGroup = this.selectedOption.filter((opt) => opt[this.optGroupBy] !== group);
            this.selectedOption = newGroup;
        },
        back() {
            this.$router.back();
        },
        closeModal() {
            $("#" + this.modalId).modal("hide");
        },
        async searchItem(val) {
            let searchKey = val.toLowerCase();
            if (this.isBiayaItem) {
                this.options = this.getItemBiaya.filter((item) => item.nama.toLowerCase().indexOf(searchKey) > -1);
            }

            if (this.isSumberDana) {
                this.options = this.getSumberDana.filter(
                    (item) => item.nama_akun.toLowerCase().indexOf(searchKey) > -1
                );
            }
        },
        async doSave() {
            if (this.isBiayaItem) {
                await this.savingItemBiaya();
            }

            if (this.isSumberDana) {
                await this.savingSumberDana();
            }
        },
        getListData() {
            this.isLoading = true;
            this.getPengaturanLaporan()
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, status, data, msg } = res.data;
                        if (status && code === 200) {
                            this.setSumberDana(data.sumberDana);
                            this.setItemBiaya(data.itemBiaya);
                        }
                    }
                    this.back();
                    this.isLoading = false;
                })
                .catch((e) => {
                    this.isLoading = false;
                    this.$toast.error(e);
                });
        },
        savingItemBiaya() {
            let idBiaya = [];
            if (this.isCheckAll) {
                this.options.forEach((opt) => {
                    idBiaya.push(opt.id);
                });
            } else {
                this.selectedOption.forEach((sel) => {
                    idBiaya.push(sel.id);
                });
            }
            this.isFetching = true;
            this.savePengaturanItemBiaya({ idBiaya: idBiaya })
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { data, status, code, msg } = res.data;

                        if (code === 200 && status) {
                            this.$toast.success(msg);
                            this.getListData();
                        } else {
                            this.$toast.error(msg);
                            this.isFetching = false;
                        }
                    }
                })
                .catch((e) => {
                    this.isFetching = false;
                    this.$toast.error(e);
                });
        },
        savingSumberDana() {
            let idAkun = [];
            if (this.isCheckAll) {
                this.options.forEach((opt) => {
                    idAkun.push(opt.idakun);
                });
            } else {
                this.selectedOption.forEach((sel) => {
                    idAkun.push(sel.idakun);
                });
            }

            this.isFetching = true;

            this.savePengaturanSumberDana({ idAkun: idAkun })
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { data, status, code, msg } = res.data;

                        if (code === 200 && status) {
                            this.$toast.success(msg);
                            this.getListData();
                        } else {
                            this.$toast.error(msg);
                            this.isFetching = false;
                        }
                    }
                })
                .catch((e) => {
                    this.isFetching = false;
                    this.$toast.error(e);
                });
        },
    },
};
</script>
<style scoped>
.check-list {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 0px 16px;
}

.check-all {
    background: #f8f8f8;
    box-sizing: border-box;
    border-bottom: 1px solid #c8d0dd;
    padding: 6px 16px;
    margin: 0px -16px;
    border-radius: 5px 5px 0px 0px;
}

.list-item {
    padding: 6px 0px;
}

.list-item-container {
    max-height: 40vh;
    overflow: hidden;
    overflow-y: scroll;
}
</style>
